(function () {
  'use strict';

  var SUBSCRIPTIONS_URL = 'https://a.klaviyo.com/client/subscriptions/';

  function getConfig(form) {
    return {
      companyId: form.getAttribute('data-klaviyo-company-id') || 'KfNGHc',
      listId: form.getAttribute('data-klaviyo-list-id') || 'KF7eaw',
      formId: form.getAttribute('data-klaviyo-form-id') || 'Q6zfnr',
      formVersion: Number(form.getAttribute('data-klaviyo-form-version') || 8366919),
      customSource: form.getAttribute('data-klaviyo-custom-source') || 'Never Miss a Sunny Deal',
      apiRevision: form.getAttribute('data-klaviyo-api-revision') || '2025-10-15',
      errorMessage: form.getAttribute('data-klaviyo-error') || 'Something went wrong. Please try again.',
    };
  }

  function showSuccessState(form) {
    var root =
      form.closest('[data-footer-newsletter]') ||
      form.closest('[data-sy-newsletter]') ||
      form.closest('.sy-newsletter');
    if (!root) return;
    var successEl = root.querySelector('[data-newsletter-success]');
    if (successEl) successEl.hidden = false;
    root.classList.add('is-success');
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function buildSubscriptionPayload(cfg, email) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  $consent_method: 'Klaviyo Form',
                  $consent_form_id: cfg.formId,
                  $consent_form_version: cfg.formVersion,
                },
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: String(cfg.listId || '').trim(),
            },
          },
        },
      },
    };
  }

  function klaviyoClientSubscribe(cfg, email) {
    var companyId = String(cfg.companyId || '').trim();
    if (!companyId) {
      return Promise.reject(new Error('MISSING_KLAVIYO_PUBLIC_KEY'));
    }

    var url = SUBSCRIPTIONS_URL + '?company_id=' + encodeURIComponent(companyId);

    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: String(cfg.apiRevision || '2025-10-15').trim(),
      },
      body: JSON.stringify(buildSubscriptionPayload(cfg, email)),
    }).then(function (res) {
      if (res.status === 202 || res.status === 200 || res.ok) {
        return res;
      }
      return res.text().then(function (txt) {
        var err = new Error('KLAVIYO_HTTP_' + res.status);
        err.status = res.status;
        err.bodyText = txt;
        try {
          err.bodyJson = JSON.parse(txt);
        } catch (e1) {}
        throw err;
      });
    });
  }

  function formatError(err, fallback) {
    if (!err) return fallback;
    if (err.message === 'MISSING_KLAVIYO_PUBLIC_KEY') {
      return 'Klaviyo is not configured.';
    }
    if (err.bodyJson && err.bodyJson.errors && err.bodyJson.errors.length) {
      var e0 = err.bodyJson.errors[0];
      return String(e0.detail || e0.title || fallback).trim();
    }
    if (err.status === 403 || err.status === 401) {
      return 'Klaviyo rejected the request. Check company ID / list ID.';
    }
    return fallback;
  }

  function setMessage(el, text, isError) {
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || '';
    el.setAttribute('data-state', isError ? 'error' : 'success');
  }

  function setSubmitting(form, submitting) {
    var btn = form.querySelector('[type="submit"]');
    var input = form.querySelector('input[type="email"]');
    if (btn) {
      btn.disabled = submitting;
      if (submitting) {
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
      }
    }
    if (input) input.disabled = submitting;
  }

  function handleSubmit(event) {
    var form = event.currentTarget;
    event.preventDefault();

    var cfg = getConfig(form);
    var input = form.querySelector('input[type="email"]');
    var messageEl = form.querySelector('[data-newsletter-message]');
    var email = input ? String(input.value || '').trim() : '';

    if (!isValidEmail(email)) {
      setMessage(messageEl, 'Please enter a valid email.', true);
      if (input) input.focus();
      return;
    }

    setMessage(messageEl, '', false);
    setSubmitting(form, true);

    klaviyoClientSubscribe(cfg, email)
      .then(function () {
        showSuccessState(form);
      })
      .catch(function (err) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[sy-newsletter-klaviyo]', err && err.status, err && err.bodyText);
        }
        setMessage(messageEl, formatError(err, cfg.errorMessage), true);
        setSubmitting(form, false);
      });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-sy-newsletter-klaviyo]');
    forms.forEach(function (form) {
      if (form.getAttribute('data-klaviyo-bound') === '1') return;
      form.setAttribute('data-klaviyo-bound', '1');
      form.addEventListener('submit', handleSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
